<!-- ================管理端-创建编辑听评课====================-->
<template>
    <div class="admin-create-container">
        <div class="admin-head-container">
            <div class="admin-left-head-container" @click="backList">
                <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#377f7f" p-id="12597" class="selected"></path></svg>
            </div>
            <div class="admin-right-head-container">{{ !lessonId ? '新增听评课' : '编辑听评课' }}</div>
        </div>
        <div class="create-content-container">
            <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                <div class="info-content-container">
                    <div class="topic-title-container">
                        <div class="topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-20.83679 8.742105-38.333279 26.238594-52.547002 17.765619-14.213723 38.87131-21.304212 63.305815-21.304212 24.452925 0 45.527916 7.090489 62.768579 21.304212 17.496489 14.213723 26.238594 31.710212 26.238594 52.547002 0 20.83679-8.742105 38.333279-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                        </div>
                        <div class="topic-title-container2">基础信息</div>
                    </div>
                    <el-row>
                        <el-col :span="15">
                            <el-row>
                                <el-col :span="18">
                                    <el-form-item label="所属机构" prop="orgId">
                                        <el-select style="width: 100%;" filterable v-model="form.orgId" placeholder="请选择所属机构">
                                            <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                                       :value="item.orgId" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="学段" prop="periodKey">
                                        <el-select style="width: 100%;" @change="changePeriod" v-model="form.periodKey" placeholder="请选择学段">
                                            <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="年级" prop="gradeKey">
                                        <el-select style="width: 100%;" @change="changeGrade" v-model="form.gradeKey" placeholder="请选择年级">
                                            <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="学科" prop="subjectKey">
                                        <el-select style="width: 100%;" v-model="form.subjectKey" placeholder="请选择学科">
                                            <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue" :value="item.dictKey" />
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="20">
                                    <el-form-item label="课程标题" prop="title">
                                        <el-input v-model="form.title" placeholder="请输入课程标题，最多60个字" maxlength="60" show-word-limit>
                                            <template #append>
                                                <el-icon @click="queryDirectory" class="cursor" :size="18"><Notebook /></el-icon>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="类型" prop="type">
                                        <el-radio-group v-model="form.type">
                                            <el-radio :label="0">推门</el-radio>
                                            <el-radio :label="1">线上</el-radio>
                                            <el-radio :label="2">录播视频</el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="20" v-if="form.type === 1">
                                    <el-form-item label="听课地址" prop="address">
                                        <el-input v-model="form.address" placeholder="请输入线上地址" maxlength="512" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="20" v-if="form.type === 2">
                                    <el-form-item label="听课地址" prop="address">
                                        <el-input v-model="form.address" placeholder="请输入视频网址或上传本地视频" maxlength="512">
                                            <template #append>
                                                <el-button @click="showUpload">上传视频</el-button>
                                            </template>
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="任务时段" prop="formTime">
                                        <div class="time-range-container">
                                            <el-date-picker v-model="form.beginTime" type="datetime" placeholder="开始时间" value-format="x" format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" @change="startDateConfirm" style="width: 220px;" />
                                            <span class="time-range-separator">至</span>
                                            <el-date-picker v-model="form.endTime" type="datetime" placeholder="结束时间" value-format="x" format="YYYY-MM-DD HH:mm" :disabled-date="enddisabledDate" @change="endDateConfirm" style="width: 220px;" />
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="评课截止时间" prop="rateEndTime">
                                        <el-date-picker v-model="form.rateEndTime" type="datetime" placeholder="请选择评课截止时间" value-format="x" format="YYYY-MM-DD HH:mm" :disabled-date="disabledDate" style="width: 100%;" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="协同备课文件" prop="lessonFileList">
                                        <selectLessonFile :showTitle="'选择备课文件'" :prepareLessonId="form.prepareLessonId" @lessonTeamUser="lessonTeamUser" ref="lessonFileList" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="1"></el-col>
                        <el-col :span="8">
                            <el-form-item label="" prop="coverUrl" label-position="top">
                                <el-upload class="event-avatar-uploader"
                                           :action="serviceUrl+'/businessservice/evaluation/uploadCover'"
                                           :show-file-list="false"
                                           :on-success="handleAvatarSuccess" :headers="{ token }"
                                           :before-upload="beforeAvatarUpload">
                                    <img alt="" v-if="form.coverUrl" :src="form.coverUrl" class="avatar" style="position:absolute" />
                                    <el-icon class="event-avatar-uploader-icon" style="font-size:100px;color:#fff;">
                                        <Plus />
                                    </el-icon>
                                </el-upload>
                                <div style="color: #a9abad;width:100%;">推荐使用540*304尺寸的图片</div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div class="topic-title-container">
                        <div class="topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-20.83679 8.742105-38.333279 26.238594-52.547002 17.765619-14.213723 38.87131-21.304212 63.305815-21.304212 24.452925 0 45.527916 7.090489 62.768579 21.304212 17.496489 14.213723 26.238594 31.710212 26.238594 52.547002 0 20.83679-8.742105 38.333279-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                        </div>
                        <div class="topic-title-container2">人员设置</div>
                    </div>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="授课教师" prop="lectureTeacher">
                                <choosePeople :showTitle="'选择人员'" :radio="true" @gxDisable="gxDisable" ref="lectureTeacher" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="评课教师" prop="rateTeacherList">
                                <choosePeople :showTitle="'选择人员'" @gxDisable="gxDisable" ref="rateTeacherList" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="听课教师" prop="listenTeacherList">
                                <choosePeople :showTitle="'选择人员'" @gxDisable="gxDisable" ref="listenTeacherList" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="指导专家" prop="guideExperts">
                                <choosePeople isTsExpertList :showTitle="'选择人员'" @gxDisable="gxDisable" ref="guideUsersList" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="评课组长" prop="leadTeacher">
                                <el-select style="width: 100%;" filterable v-model="form.leadTeacher" placeholder="请选择评课组长">
                                    <el-option v-for="item in leadTeacherList" :key="item.userId" :label="item.trueName || item.userId" :value="item.userId" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div class="topic-title-container">
                        <div class="topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-20.83679 8.742105-38.333279 26.238594-52.547002 17.765619-14.213723 38.87131-21.304212 63.305815-21.304212 24.452925 0 45.527916 7.090489 62.768579 21.304212 17.496489 14.213723 26.238594 31.710212 26.238594 52.547002 0 20.83679-8.742105 38.333279-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                        </div>
                        <div class="topic-title-container2">量表设置</div>
                    </div>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="听评量表" prop="scaleIds">
                                <el-select style="width:100%" multiple filterable v-model="form.scaleList" placeholder="请选择听评量表">
                                    <el-option v-for="item in rateScaleList" :key="item.scaleId" :label="item.title" :value="item.scaleId">
                                        <span style="float: left">{{ item.title }}</span>
                                        <span @click.stop="preview(item)" style="float: right; color: #8492a6; font-size: 13px">
                                            <el-icon>
                                                <View />
                                            </el-icon>
                                        </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div class="topic-title-container" v-if="form.type === 0">
                        <div class="topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-20.83679 8.742105-38.333279 26.238594-52.547002 17.765619-14.213723 38.87131-21.304212 63.305815-21.304212 24.452925 0 45.527916 7.090489 62.768579 21.304212 17.496489 14.213723 26.238594 31.710212 26.238594 52.547002 0 20.83679-8.742105 38.333279-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                        </div>
                        <div class="topic-title-container2">听课地点</div>
                    </div>
                    <el-row v-if="form.type === 0">
                        <el-col :span="12">
                            <el-form-item label="听课地址" prop="address">
                                <el-input v-model="form.address" placeholder="请使用地图选择听课地址" maxlength="256" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="" v-show="form.type === 0">
                        <aMap v-if="isShow" ref="zdyMap" style="width: 660px" @getGeocoder="getGeocoder" :oldCenter="oldCenter" :isShowAMap="true">
                        </aMap>
                    </el-form-item>

                    <div class="topic-title-container">
                        <div class="topic-title-container1">
                            <svg t="1746000464466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12409" width="22" height="22"><path d="M512 0.021489c-282.758945 0-511.978511 229.219565-511.978511 511.978511s229.219565 511.978511 511.978511 511.978511c282.752806 0 511.978511-229.219565 511.978511-511.978511S794.752806 0.021489 512 0.021489zM650.535193 799.341311c-30.110785 10.406001-53.770648 18.430768-71.779813 24.12035-17.759479 5.683443-38.609343 8.524141-62.269205 8.524141-36.280298 0-64.599274-8.057513-84.656075-23.679305-20.332071-16.089443-30.366611-35.953863-30.366611-60.573587 0-9.465582 0.76748-18.936281 2.297322-28.869514 1.567705-9.93221 4.121877-21.304212 7.225565-33.617655l37.547151-118.810966c3.353374-11.340279 1.453095-21.74628 3.78828-32.177863 2.316765-9.93221 3.333932-19.397792 3.333932-27.429723 0-15.647375 1.433652-26.053376-5.528923-31.742958-7.219425-6.15007-20.312628-4.383844-40.139186-4.383844-9.804297 0-19.832697 1.408069-29.854958 3.776-10.290367 2.847861-19.032472 0.607844-26.251897 3.455705l10.060123-36.926004c24.427342-8.997931 48.087205-16.562211 70.499657-22.719444 22.39301-6.617721 43.722804-9.458419 63.549362-9.458419 36.274158 0 64.09376 7.583722 83.631746 23.205515 19.551288 15.621792 41.169655 35.960003 41.169655 60.579727 0 5.215792-0.800225 14.213723-2.080382 27.461445-1.274016 12.773931-3.858888 24.613584-7.468089 35.486212L563.843762 673.880901c-2.847861 9.465582-5.65786 20.363793-7.986905 32.677237-2.585895 11.839653-3.858888 21.304212-3.858888 27.455305 0 15.621792 4.114714 26.494421 11.845793 32.184003 7.980765 5.65786 21.618367 8.498558 40.900525 8.498558 9.011234 0 19.321044-1.408069 30.878265-4.224208 11.564383-2.841721 19.800975-5.215792 24.946159-7.589862L650.535193 799.341311zM643.860167 319.355445c-17.240663 14.681374-38.315654 21.771863-62.768579 21.771863-24.434505 0-45.540196-7.090489-63.305815-21.771863-17.496489-14.213723-26.238594-31.710212-26.238594-52.547002 0-20.83679 8.742105-38.333279 26.238594-52.547002 17.765619-14.213723 38.87131-21.304212 63.305815-21.304212 24.452925 0 45.527916 7.090489 62.768579 21.304212 17.496489 14.213723 26.238594 31.710212 26.238594 52.547002 0 20.83679-8.742105 38.333279-26.238594 52.547002z" fill="#377f7f" p-id="12410"></path></svg>
                        </div>
                        <div class="topic-title-container2">附件资料</div>
                    </div>
                    <el-row>
                        <el-col :span="20">
                            <el-form-item label="上传附件" prop="">
                                <el-upload v-model:file-list="fileList" style="width: 100%"
                                           :action="serviceUrl+'/businessservice/evaluation/uploadFile'"
                                           :on-remove="handleRemove" :on-change="handleFileChange"
                                           :headers="{ token }" accept=".pdf,.ppt,.pptx,.doc,.docx"
                                           :before-upload="beforeFileUpload">
                                    <el-button type="primary">点击上传</el-button>
                                    <template #tip>
                                        <div class="el-upload__tip">只允许上传.pdf,.ppt,.pptx,.doc,.docx格式文件。</div>
                                    </template>
                                </el-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
            <div class="dis-flex-row-center cus-btn">
                <el-button type="primary" @click="submitForm">保 存</el-button>
                <el-button @click="backList">取 消</el-button>
            </div>
        </div>

        <el-dialog :title="previewData.title ? previewData.title : '预览'" v-model="previewShow" width="60%">
            <div class="mb30" v-for="(item, index) in previewData.questionList" :key="index">
                <div class="mb15" v-if="item.type != 3">
                    <h3 style="margin: 0 0;"><span style="padding-right: 10px;">{{ index + 1 }}.</span>{{ item.questionName }}
                        <span style="padding-left: 10px;color: #999;font-weight: normal;font-size: 14px;">[{{
                            item.type == 1 ? '单选' : item.type == 2 ? '多选' : item.type == 3 ? '评分' : item.type == 4 ? '文字内容' : ''
                        }}]</span>
                        <span v-if="item.type == 4 && item.totalScore" style="color: #efa030;font-weight: normal;font-size: 14px;">(分值：{{ item.totalScore }})</span>
                        <span v-if="item.type == 3" style="color: #efa030;font-weight: normal;font-size: 14px;">(满分：{{ item.totalScore }})</span>
                    </h3>
                </div>
                <div v-if="item.type == 1">
                    <el-radio-group disabled class="ml-4">
                        <el-radio label="1" size="small" v-for="(items, indexs) in item.itemList" :key="indexs">
                            <span style="color: #333;">{{ items.itemName }}</span><span style="color: #efa030;">(分值：{{ items.itemValue }})</span>
                        </el-radio>
                    </el-radio-group>
                </div>
                <div v-if="item.type == 2">
                    <el-checkbox-group disabled class="ml-4">
                        <el-checkbox size="small" v-for="(items, indexs) in item.itemList" :key="indexs">
                            <span style="color: #333;">{{ items.itemName }}</span><span style="color: #efa030;">(分值：{{ items.itemValue }})</span>
                        </el-checkbox>
                    </el-checkbox-group>
                </div>
                <div v-if="item.type == 4" style="width: 100%;">
                    <el-input style="width: 100%;" disabled :rows="2" type="textarea" placeholder="" />
                </div>
            </div>
        </el-dialog>

        <el-dialog title="课程目录" v-model="isDirectory" width="60%">
            <el-row>
                <el-empty v-if="directoryList.length == 0" style="margin: 0 auto;" description="暂无数据" />
                <div style="margin-bottom: 15px;margin-right:40px;" v-for="item in directoryList" :key="item.classId">
                    <el-card @click="goCourse(item)" class="cursor" style="width: 150px;">
                        <div class="csbbb">
                            <el-image fit="cover" style="width: 130px;height:185px" :src="item.coverUrl"></el-image>
                        </div>
                        <div class="mt5 text-one">{{ item.className }}</div>
                    </el-card>
                </div>
            </el-row>
        </el-dialog>

        <el-dialog title="课程目录" v-model="isCourse" width="60%">
            <el-table :data="tableData" :span-method="objectSpanMethod" border style="width: 100%; margin-top: 20px">
                <el-table-column prop="ptit" label="单元名" width="180">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;">
                            <div @click="changeTitle(scope.row)" :style="scope.row.title ? '' : 'color: #409efe;'"
                                 :class="scope.row.title ? '' : 'cursor'" :title="scope.row.ptit" class="text-one">
                                {{ scope.row.ptit }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="课程名">
                    <template #default="scope">
                        <div style="display: flex;justify-content: space-between;" v-if="scope.row.id">
                            <div @click="changeTitle(scope.row)" :title="scope.row.title" style="color: #409efe;"
                                 class="text-one cursor">
                                {{ scope.row.title }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog title="上传本地视频" v-model="evaVideoIsDisplay" width="30%">
            <el-upload ref="upload"
                       class="upload-demo"
                       :limit="1"
                       :on-exceed="handleExceed"
                       accept=".mp4,.avi,.flv" :http-request="handleUpload">
                <el-button type="primary">点击上传</el-button>
                <template #tip>
                    <div class="el-upload__tip">
                        只允许上传.mp4,.avi,.flv,格式文件。
                    </div>
                </template>
            </el-upload>
        </el-dialog>
    </div>
</template>

<script>
import aMap from '@/components/aMap/index.vue'
import { queryDict } from "@/api/admin/dict";
import { queryUserManagerOrg } from "@/api/admin/org";
import { rateScaleList, evaluationCreate, evaluationInfo, evaluationUpdate, rateScaleInfo } from "@/api/admin/evaluation";
import { listClassLibrary, infoLibrary } from "@/api/admin/classLibrary";
import choosePeople from "@/components/choosePeople.vue"
import selectLessonFile from "@/components/selectLessonFile"
import { serviceUrl } from "@/utils/global";
import { ElLoading } from 'element-plus'
import { getFileNameUUID, signatureUrl } from "@/utils/tools";
import { ossClient } from "@/utils/global";

export default {
    name: "evaLessonCreate",
    components: { aMap, choosePeople, selectLessonFile },
    data() {
        return {
            serviceUrl,
            isShow: false,
            oldCenter: [],
            rateScaleList: [],
            lessonId: '',
            periodList: [],
            gradeList: [],
            subjectList: [],
            token: this.$storage.get("token"),
            loading: false,
            orgList: [],
            form: {
                coverUrl: 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png',
                orgId: '',
                countyId: '',
                schoolId: '',
                type: 0,
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                title: '',
                lectureTeacher: '',
                rateTeachers: '',
                rateTeacherList: [],
                listenTeacherList: [],
                guideUsersList: [],
                scaleIds: '',
                scaleList: [],
                address: '',
                rateEndTime: '',
                leadTeacher: '',
                guideExperts: '',
                beginTime: '',
                endTime: '',
                lat: '',
                lng: '',
                prepareLessonId: '',
                lessonFiles: '',
                lessonFileList: [],
            },
            rules: {
                orgId: [
                    { required: true, message: "请选择所属机构", trigger: "change" },
                ],
                periodKey: [
                    { required: true, message: "请选择学段", trigger: "change" },
                ],
                gradeKey: [
                    { required: true, message: "请选择年级", trigger: "change" },
                ],
                subjectKey: [
                    { required: true, message: "请选择学科", trigger: "change" },
                ],
                rateEndTime: [
                    { required: true, message: "请选择评课截止时间", trigger: "change" },
                ],
                title: [
                    { required: true, message: "请输入课程标题", trigger: "blur" },
                ],
                type: [
                    { required: true, message: "请选择类型", trigger: "change" },
                ],
                address: [
                    { required: true, message: "请输入听课地址", trigger: "blur" },
                ],
                lectureTeacher: [
                    { required: true, validator: this.checkLectureTeacher },
                ],
                rateTeacherList: [
                    { required: true, validator: this.checkrateTeacherList },
                ],
                listenTeacherList: [
                    { required: true, validator: this.checklistenTeacherList },
                ],
                formTime: [
                    { required: true, validator: this.checkValidator }
                ],
                coverUrl: [
                    { required: true, validator: this.checkCoverValidator }
                ],
            },
            previewData: {},
            previewShow: false,
            leadTeacherList: [],
            fileList: [],
            isDirectory: false,
            isCourse: false,
            directoryList: [],
            tableData: [],
            evaVideoIsDisplay: false,
            ossClient,
        };
    },
    created() {
        this.queryUserManagerOrg();
        this.getRateScaleList();
    },
    mounted() {
        this.getQueryDict().then(() => {
            if (this.$route.query.lessonId) {
                this.lessonId = this.$route.query.lessonId
                this.getlessonInfo()
            } else {
                this.isShow = true
            }
        })
    },
    methods: {
        backList() {
            this.$router.push({ path: "/evaLesson" });
        },
        queryUserManagerOrg() {
            queryUserManagerOrg().then(res => {
                if (res.data && res.data.code === 1) {
                    this.orgList = res.data.data || [];
                }
            })
        },
        getQueryDict() {
            return queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.periodList = res.data.data || [];
                }
            })
        },
        getRateScaleList() {
            rateScaleList({ scaleType: 1 }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.rateScaleList = res.data.data || [];
                }
            })
        },
        changePeriod() {
            this.form.gradeKey = '';
            this.form.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (String(this.form.periodKey) === String(j.dictKey)) {
                    this.gradeList = j.childrenList || [];
                }
            })
        },
        changeGrade() {
            this.form.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (String(this.form.periodKey) === String(e.dictKey)) {
                    (e.childrenList || []).forEach(j => {
                        if (String(this.form.gradeKey) === String(j.dictKey)) {
                            this.subjectList = j.childrenList || [];
                        }
                    })
                }
            })
        },
        initCascaderList() {
            this.periodList.forEach(j => {
                if (String(this.form.periodKey) === String(j.dictKey)) {
                    this.gradeList = j.childrenList || [];
                }
            })
            this.periodList.forEach(e => {
                if (String(this.form.periodKey) === String(e.dictKey)) {
                    (e.childrenList || []).forEach(j => {
                        if (String(this.form.gradeKey) === String(j.dictKey)) {
                            this.subjectList = j.childrenList || [];
                        }
                    })
                }
            })
        },
        queryDirectory() {
            listClassLibrary({
                className: '',
                periodKey: this.form.periodKey || '',
                gradeKey: this.form.gradeKey || '',
                subjectKey: this.form.subjectKey || '',
            }).then(res => {
                if (res.data.code === 1) {
                    this.directoryList = JSON.parse(JSON.stringify(res.data.data || []));
                    this.isDirectory = true;
                } else {
                    this.$message.error(res.data.msg || "请求出错")
                }
            });
        },
        goCourse(item) {
            this.tableData = []
            infoLibrary({ classId: item.classId }).then(res => {
                if (res.data.code === 1) {
                    const data = res.data.data || {};
                    (data.childrenList || []).forEach(j => {
                        if (j.childrenList && j.childrenList.length) {
                            j.childrenList.forEach((m, n) => {
                                if (n == 0) {
                                    this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: j.childrenList.length, className: data.className })
                                } else {
                                    this.tableData.push({ pid: j.classId, ptit: j.className, id: m.classId, title: m.className, col: 0, className: data.className })
                                }
                            })
                        } else {
                            this.tableData.push({ pid: j.classId, ptit: j.className, id: '', title: '', col: 1, className: data.className })
                        }
                    })
                    this.isCourse = true
                } else {
                    this.$message.error(res.data.msg || '请求出错')
                }
            })
        },
        changeTitle(row) {
            this.form.title = row.className + '—' + row.ptit + (row.title ? '—' + row.title : '')
            this.isDirectory = false;
            this.isCourse = false;
        },
        objectSpanMethod(e) {
            if (e.columnIndex === 0) {
                if (e.row.col != 0) {
                    return {
                        rowspan: e.row.col,
                        colspan: 1,
                    }
                } else {
                    return {
                        rowspan: 0,
                        colspan: 0,
                    }
                }
            }
        },
        lessonTeamUser(userList) {
            this.$refs.listenTeacherList.checkList = userList || [];
            this.gxDisable();
            this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
        },
        gxDisable() {
            this.$refs.lectureTeacher.disabledList = [...this.$refs.rateTeacherList.checkList, ...this.$refs.listenTeacherList.checkList]
            this.$refs.rateTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.listenTeacherList.checkList]
            this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
            this.$refs.guideUsersList.disabledList = [...this.$refs.lectureTeacher.checkList]
            this.leadTeacherList = [];
            this.$refs.rateTeacherList.checkList.forEach(e => {
                this.leadTeacherList.push(e)
            })
            const rateCheckList = []
            this.$refs.rateTeacherList.checkList.forEach(e => {
                rateCheckList.push(e.userId)
            })
            if (rateCheckList.indexOf(this.form.leadTeacher) === -1) {
                this.form.leadTeacher = ''
            }
            // 同步表单 model，触发 Element Plus 校验状态更新
            this.form.lectureTeacher = this.$refs.lectureTeacher.checkList.length ? this.$refs.lectureTeacher.checkList[0].userId : ''
            this.form.rateTeacherList = this.$refs.rateTeacherList.checkList.map(e => e.userId)
            this.form.listenTeacherList = this.$refs.listenTeacherList.checkList.map(e => e.userId)
            this.$forceUpdate()
            if (this.$refs.form) {
                this.$refs.form.validateField(['lectureTeacher', 'rateTeacherList', 'listenTeacherList'])
            }
        },
        preview(item) {
            rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.previewData = res.data.data;
                    this.previewShow = true;
                }
            })
        },
        getGeocoder(e) {
            if (this.form.type === 0) {
                this.form.lat = e.center[1];
                this.form.lng = e.center[0];
                this.form.address = e.formattedAddress;
            }
        },
        getlessonInfo() {
            evaluationInfo({ lessonId: this.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.form = res.data.data || {};
                    // 确保字段存在
                    if (!this.form.coverUrl) {
                        this.form.coverUrl = 'https://free-back.oss-cn-beijing.aliyuncs.com/ygjy/default/szpx.png';
                    }
                    if (!this.form.type && this.form.type !== 0) {
                        this.form.type = 0;
                    }
                    this.form.orgId = this.form.countyId || this.form.schoolId || '';
                    this.form.scaleList = this.form.scaleIds && this.form.scaleIds.split(',') || [];

                    // 级联数据回显
                    this.initCascaderList()

                    this.$nextTick(() => {
                        const formatUserList = (list) => {
                            if (!list || !list.length) return [];
                            return list.map(e => typeof e === 'object' ? e : { userId: e });
                        };
                        if (this.form.lectureTeacher) {
                            this.$refs.lectureTeacher.checkList = [{
                                userId: this.form.lectureTeacher,
                                trueName: this.form.lectureTeacherName
                            }];
                        }
                        this.$refs.rateTeacherList.checkList = formatUserList(this.form.rateTeacherList);
                        this.$refs.listenTeacherList.checkList = formatUserList(this.form.listenTeacherList);
                        this.$refs.guideUsersList.checkList = formatUserList(this.form.guideUserList || this.form.guideUsersList);
                        if (this.$refs.lessonFileList) {
                            this.$refs.lessonFileList.checkFileList = this.form.lessonFileList || [];
                        }
                        this.gxDisable();
                        this.$refs.lectureTeacher.disabledList = [...this.$refs.rateTeacherList.checkList, ...this.$refs.listenTeacherList.checkList]
                        this.$refs.rateTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.listenTeacherList.checkList]
                        this.$refs.listenTeacherList.disabledList = [...this.$refs.lectureTeacher.checkList, ...this.$refs.rateTeacherList.checkList]
                    });

                    if (this.form.type === 0) {
                        this.oldCenter = [this.form.lng, this.form.lat]
                    }
                    this.form.fileList = this.form.fileList || [];
                    this.fileList = [];
                    this.form.fileList.forEach(e => {
                        this.fileList.push({
                            name: e.fileName,
                            fileId: e.fileId,
                            url: e.fileUrl,
                            response: { data: e.fileUrl }
                        })
                    })
                    this.isShow = true;
                    if (this.form.type === 0) {
                        setTimeout(() => {
                            if (this.$refs.zdyMap) {
                                this.$refs.zdyMap.center = this.oldCenter;
                                this.$refs.zdyMap.componentMarker.position = this.oldCenter;
                            }
                        }, 100)
                    }
                }
            })
        },
        handleRemove(file, uploadFiles) {
            console.log(file, uploadFiles)
        },
        handleFileChange(file) {
            console.log(file)
        },
        beforeFileUpload(rawFile) {
            if (!(rawFile.type === 'application/pdf' ||
                rawFile.type === 'application/vnd.ms-powerpoint' ||
                rawFile.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation' ||
                rawFile.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
                rawFile.type === 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        startDateConfirm(e) {
            if (e >= this.form.endTime) {
                this.form.endTime = '';
            }
        },
        endDateConfirm(e) {
            if (e <= this.form.beginTime) {
                this.form.beginTime = '';
            }
        },
        checkValidator(rule, value, callback) {
            if (!this.form.beginTime) {
                callback(new Error('请选择开始日期'))
            } else if (!this.form.endTime) {
                callback(new Error('请选择结束日期'))
            } else {
                callback()
            }
        },
        disabledDate(current) {
            return current && current < Number(new Date()) - 86400000
        },
        enddisabledDate(current) {
            if (this.form.beginTime) {
                return current && current < this.form.beginTime
            } else {
                return current && current < Number(new Date()) - 86400000
            }
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response && uploadFile.response.code === 1) {
                this.form.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }
        },
        beforeAvatarUpload(rawFile) {
            if (!(rawFile.type === 'image/jpeg' || rawFile.type === 'image/png' || rawFile.type === 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        checkCoverValidator(rule, value, callback) {
            if (this.form.coverUrl && this.form.coverUrl !== '') {
                callback()
            } else {
                callback(new Error('请上传封面'))
            }
        },
        checkLectureTeacher(rule, value, callback) {
            if (this.$refs.lectureTeacher.checkList.length === 0) {
                callback(new Error('请选择授课教师'))
            } else {
                callback()
            }
        },
        checkrateTeacherList(rule, value, callback) {
            if (this.$refs.rateTeacherList.checkList.length === 0) {
                callback(new Error('请选择评课教师'))
            } else {
                callback()
            }
        },
        checklistenTeacherList(rule, value, callback) {
            if (this.$refs.listenTeacherList.checkList.length === 0) {
                callback(new Error('请选择听课教师'))
            } else {
                callback()
            }
        },
        submitForm() {
            this.form.beginTime = this.setHms(this.form.beginTime);
            this.form.endTime = this.setHms(this.form.endTime);
            this.form.rateEndTime = this.setHms(this.form.rateEndTime);

            if (this.$refs.lectureTeacher.checkList.length !== 0) {
                this.form.lectureTeacher = this.$refs.lectureTeacher.checkList[0].userId;
            } else {
                this.form.lectureTeacher = '';
            }
            this.form.rateTeacherList = [];
            this.$refs.rateTeacherList.checkList.forEach(e => {
                this.form.rateTeacherList.push(e.userId)
            })
            this.form.rateTeachers = this.form.rateTeacherList.toString()
            this.form.listenTeacherList = [];
            this.$refs.listenTeacherList.checkList.forEach(e => {
                this.form.listenTeacherList.push(e.userId)
            })
            this.form.listenTeachers = this.form.listenTeacherList.toString()
            this.form.guideUsersList = [];
            this.$refs.guideUsersList.checkList.forEach(e => {
                this.form.guideUsersList.push(e.userId)
            })
            this.form.guideExperts = this.form.guideUsersList.toString()

            this.form.lessonFileList = [];
            if (this.$refs.lessonFileList) {
                this.$refs.lessonFileList.checkFileList.forEach(e => {
                    this.form.lessonFileList.push(e.fileId)
                })
                this.form.lessonFiles = this.form.lessonFileList.toString()
                this.form.prepareLessonId = this.$refs.lessonFileList.lessonId;
            }

            const fileList = [];
            this.fileList.forEach((e) => {
                if (e.response && e.response.data) {
                    fileList.push(e.response.data);
                }
            })

            this.$refs["form"].validate(valid => {
                if (valid) {
                    const loading = ElLoading.service({ fullscreen: true })
                    var obj = JSON.parse(JSON.stringify(this.form));
                    obj.fileUrls = fileList.toString();
                    if (obj.type === 1 || obj.type === 2) {
                        obj.lat = ''
                        obj.lng = ''
                    }
                    obj.scaleIds = obj.scaleList.toString();
                    obj.countyId = obj.orgId
                    obj.schoolId = obj.orgId
                    delete obj.rateTeacherList
                    delete obj.scaleList
                    delete obj.fileList
                    delete obj.orgId

                    if (this.lessonId) {
                        evaluationUpdate(obj).then(res => {
                            loading.close()
                            if (res.data && res.data.code === 1) {
                                this.$message.success("编辑成功");
                                this.backList()
                            } else {
                                this.$message.error(res.data.msg || "操作失败")
                            }
                        }).catch(() => {
                            loading.close()
                        });
                    } else {
                        evaluationCreate(obj).then(res => {
                            loading.close()
                            if (res.data && res.data.code === 1) {
                                this.$message.success("新增成功");
                                this.backList()
                            } else {
                                this.$message.error(res.data.msg || "操作失败")
                            }
                        }).catch(() => {
                            loading.close()
                        })
                    }
                }
            });
        },
        showUpload() {
            this.evaVideoIsDisplay = true;
        },
        handleExceed() {
        },
        handleUpload(option) {
            const loading = ElLoading.service({ fullscreen: true })
            var obj = option.file.name
            const index = obj.lastIndexOf(".");
            obj = obj.substring(index, obj.length);
            let objName = getFileNameUUID() + this.getFileName(option.file.name)
            this.multipartUpload(`/ygjy/user-video/${objName}`, option.file).then(res => {
                signatureUrl(`/ygjy/user-video/${objName}`).then(res => {
                    var lastQuestionMarkIndex = res.lastIndexOf("?")
                    var result = res;
                    if (lastQuestionMarkIndex !== -1) {
                        result = res.substring(0, lastQuestionMarkIndex);
                    }
                    this.form.address = result;
                    loading.close()
                    this.evaVideoIsDisplay = false;
                }).catch(() => {
                    loading.close()
                })
            }).catch(() => {
                loading.close()
            })
        },
        async multipartUpload(ObjName, fileUrl) {
            try {
                let result = await this.ossClient.multipartUpload(`${ObjName}`, fileUrl, {
                    progress: (p, cpt, res) => {
                        console.log(p);
                    },
                    timeout: 600000000,
                    parallel: 9999,
                    partSize: 1024 * 1024 * (50),
                })
                return result
            } catch (e) {
                this.$message.error('上传失败')
            }
        },
        getFileName(name) {
            return name.substring(name.lastIndexOf("."));
        },
    }
};
</script>

<style scoped>
.event-avatar-uploader .avatar {
    width: 270px;
    height: 152px;
    display: block;
    object-fit: cover;
}

.event-avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.event-avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}

.el-icon.event-avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 270px;
    height: 152px;
    text-align: center;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

/deep/ .el-dialog__body {
    padding: 10px 20px !important;
}

.info-content-container {
    width: 100%;
    height: auto;
    padding: 0 10px 80px 10px;
    box-sizing: border-box;
}

.topic-title-container {
    width: 100%;
    height: 40px;
    display: flex;
}

.topic-title-container1 {
    width: 30px;
    height: 40px;
    box-sizing: border-box;
    padding-top: 10px;
}

.topic-title-container2 {
    width: 110px;
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: bold;
    color: #377f7f;
}

.time-range-container {
    display: flex;
    align-items: center;
}

.time-range-separator {
    margin: 0 10px;
    color: #606266;
}

.dis-flex-row-center {
    display: flex;
    justify-content: center;
    align-items: center;
}

.cus-btn {
    padding-bottom: 15px;
}

.cus-btn .el-button--primary {
    background-color: #377f7f;
    border-color: #377f7f;
}

.text-center {
    text-align: center;
}

.cursor {
    cursor: pointer;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    position: relative;
}

.text-one {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
</style>
